// removed by extract-text-webpack-plugin
module.exports = {"header":"header__vYTIE","active":"active__1dG5s"};


//////////////////
// WEBPACK FOOTER
// ./components/header/header.scss
// module id = MIN7
// module chunks = 0